// class EarlyAccessDrawer extends Drawer {}
// customElements.define("early-access-drawer", EarlyAccessDrawer);

// class EarlyAccessDrawerButton extends DrawerButton {}
// customElements.define("early-access-drawer-button", EarlyAccessDrawerButton);

class EarlyAccessDrawer extends HTMLElement {
  connectedCallback() {
    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("[id*=-Overlay]").addEventListener("click", this.close.bind(this));
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      document.querySelector("mobile-menu").mobilemenuHide();
      document.body.classList.add("drawer--isActive");
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : this.firstElementChild;
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    setTimeout(() => {
      document.body.classList.remove("drawer--isActive");
      this.increaseMobileMenuButtonIndex();
    }, 300);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  increaseMobileMenuButtonIndex() {
    const mobileMenuButton = document.querySelector(".mobile-menu-toggle");
    if (mobileMenuButton) {
      mobileMenuButton.style.zIndex = "999999999";
    }
  }
}

customElements.define("early-access-drawer", EarlyAccessDrawer);

class EarlyAccessDrawerButton extends EarlyAccessDrawer {
  drawerTag = null;
  drawerId = null;
  drawer = null;

  connectedCallback() {
    this.drawerTag = this.dataset.drawerTag;
    let action = this.dataset.action ? this.dataset.action : "open";

    this.addEventListener("click", () => {
      this.handleClick();
    });

    if (action === "redirect") {
      return;
    }

    if (!this.drawerTag) {
      return;
    }

    this.drawerId = this.dataset.drawerId;
    if (!this.drawerId || !this.drawerTag) {
      return;
    }

    const el = document.getElementById(this.drawerId);
    if (!el) {
      return;
    }

    this.drawer = el.closest(this.drawerTag);
  }

  reduceMobileMenuButtonIndex() {
    const mobileMenuButton = document.querySelector(".mobile-menu-toggle");
    if (mobileMenuButton) {
      mobileMenuButton.style.zIndex = "1";
    }
  }

  handleClick() {
    let action = this.dataset.action ? this.dataset.action : "open";

    if (action === "redirect") {
      const url = this.dataset.redirectUrl;
      if (url) {
        window.location.href = url;
      }
      return;
    }
    
    const isSizeGuideDrawer = this.drawerTag === "size-guide-drawer";
    if (action === "open") {
      this.drawer.open();
      if (isSizeGuideDrawer) {
        this.reduceMobileMenuButtonIndex();
      }
    } else {
      this.drawer.close();
    }
  }
}

customElements.define("early-access-drawer-button", EarlyAccessDrawerButton);
